var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('container',{staticClass:"my-120 md-my-90 px-15",attrs:{"width":"md"}},[_c('div',{staticClass:"text-21 md-text-46 leading-xs tracking-tight text-center",domProps:{"innerHTML":_vm._s(_vm.row.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }